<template>
  <div class="operation-intro">
    <header class="operation-header">
      <div><span class="operation-eyebrow">设备运维</span><h2>{{ title }}</h2><p>{{ description }}</p></div>
      <Button icon="ios-arrow-back" @click="$emit('back')">返回上一页</Button>
    </header>
    <div class="operation-device-context" aria-label="当前设备">
      <div><span>当前设备</span><strong>{{ device.deviceName || device.name || port || '未指定设备' }}</strong></div>
      <div><span>所属工厂</span><strong>{{ device.factoryName || device.factorName || '未提供工厂信息' }}</strong></div>
      <div><span>机器端口 / 类型</span><strong>{{ port || '未提供端口' }} <small>· {{ typeLabel }}</small></strong></div>
      <div><span>设备 ID</span><strong>{{ device.deviceId || device.id || '未指定' }}</strong></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceOperationHeader',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    device: { type: Object, default: () => ({}) }
  },
  computed: {
    port () { return this.device.macAddress || this.device.mac_address || this.device.port || '' },
    typeLabel () {
      const type = this.device.type || ''
      return { aiqc: 'AIQC', online: '在线设备' }[String(type).toLowerCase()] || type || '类型未提供'
    }
  }
}
</script>

<style lang="less">
@import './device-operation.less';
</style>
